import React, { useState, useEffect, useContext } from "react";
import CartContext from "../../../context/CartContext";
import { ProductsContext } from "../../../context/ProductsContext";
const ProductAddToCart = (props) => {
  console.log("CLG ITEM INSIDE THE PRODUCT ADD TO CART", props);
  let sizes = [
    4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12,
    12.5,
  ];
  const { cartItems, addToCart } = useContext(CartContext);
  const { title, image_url, price, quantity, id, description } = props;

  // console.log("CLG AFTER DESTR ITEM INSIDE THE PRODUCT ADD TO CART", product);
  console.log("INSIDE PRODUCTADDTOCART", cartItems);
  const [selectedSize, setSelectedSize] = useState("");

  const showAllSizes = () => {
    return sizes.map((size) => {
      return (
        <div
          key={size}
          className={`option ${selectedSize === size ? "selected" : ""}`}
          onClick={(e) => {
            setSelectedSize(size);
          }}
        >
          {size}
        </div>
      );
    });
  };
  //   const clickedSize = (selectedSize) => {
  //     setSelectedSize(
  //       {
  //         selectedSize,
  //       },
  //       () => {
  //         console.log(setSelectedSize);
  //       }
  //     );
  //   };
  const clickedAddToCartBtn = () => {
    if (selectedSize !== "") {
      console.log(`Added Product Size ${selectedSize}`);
      const product = {
        title,
        image_url,
        price,
        quantity,
        id,
        description,
        size: selectedSize,
      };

      addToCart(product);
      //   const item = {
      //       title:
      //   }
    } else {
      window.alert('Pleae Select a Size')
    }
  };
  // const {title, image_url,price, idm}
  return (
    <div className="add-to-cart">
      <div className="detail-section">
        <div className="detail">
          <input type="checkbox" id="size-dropdown" className="toggle" />
          <label className="title size-title" htmlFor="size-dropdown">
            Size
          </label>
          <div className="content">
            <div className="sizes">{showAllSizes()}</div>
          </div>
        </div>
      </div>
      <div className="button-area">
        <div className="button" onClick={clickedAddToCartBtn}>
          Add to cart
        </div>
      </div>
    </div>
  );
};

export default ProductAddToCart;

// import React, { useState, useEffect, useContext } from "react";
// import CartContext from "../../../context/CartContext";
// import { ProductsContext } from "../../../context/ProductsContext";
// const ProductAddToCart = (product) => {
//   console.log("CLG ITEM INSIDE THE PRODUCT ADD TO CART", product);
//   let sizes = [
//     4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12,
//     12.5,
//   ];
//   const { cartItems, addToCart } = useContext(CartContext);
//   console.log("INSIDE PRODUCTADDTOCART", cartItems);
//   const [selectedSize, setSelectedSize] = useState("");

//   const showAllSizes = () => {
//     return sizes.map((size) => {
//       return (
//         <div
//           key={size}
//           className={`option ${selectedSize === size ? "selected" : ""}`}
//           onClick={(e) => {
//             setSelectedSize(size);
//           }}
//         >
//           {size}
//         </div>
//       );
//     });
//   };
//   //   const clickedSize = (selectedSize) => {
//   //     setSelectedSize(
//   //       {
//   //         selectedSize,
//   //       },
//   //       () => {
//   //         console.log(setSelectedSize);
//   //       }
//   //     );
//   //   };
//   const clickedAddToCartBtn = () => {
//     if (selectedSize !== "") {
//       console.log(`Added Product Size ${selectedSize}`);
//       const item = {
//         title: product.title,
//         image_url: product.image_url,
//         price: product.price,
//         size: selectedSize,
//       };
//       addToCart(item);
//       //   const item = {
//       //       title:
//       //   }
//     } else {
//       console.log(`sorry need to add a size`);
//     }
//   };

//   return (
//     <div className="add-to-cart">
//       <div className="detail-section">
//         <div className="detail">
//           <input type="checkbox" id="size-dropdown" className="toggle" />
//           <label className="title size-title" htmlFor="size-dropdown">
//             Size
//           </label>
//           <div className="content">
//             <div className="sizes">{showAllSizes()}</div>
//           </div>
//         </div>
//       </div>
//       <div className="button-area">
//         <div className="button" onClick={clickedAddToCartBtn}>
//           Add to cart
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProductAddToCart;
